(function() {
	// globals
	PM.About = {};


	// utility functions

	// app functions
	PM.About.renderAboutPage = function() {
		PM.Shell.setSidebarActive('');
		PM.Shell.setBreadcrumb([{ label: i18next.t('About') }]);
		$('.js-page-container').html(ejs.rr('/app/about/templates/about.ejs'));
	};

	// events

	// app startup
	page('/about', PM.About.renderAboutPage);
})();
